<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm09_plates"><a id="page_xvii"></a>PLATES</h2>
<p class="noindent2">P<span class="small">LATES</span></p>
<p class="rightr"><em>following page <span class="nounder" href="#/xhtml/ch13#page_364" title="Link target outside of Sample">364</span></em></p>
<table cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat1" title="Link target outside of Sample">I.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat1" title="Link target outside of Sample">Carved stone heads from Texas</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat2" title="Link target outside of Sample">II.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat2" title="Link target outside of Sample">Tonkawas: Grant Richards, Winnie Richards, Sherman Niles, and William Stevens</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat3" title="Link target outside of Sample">III.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat3" title="Link target outside of Sample">A group of Tonkawas</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat4" title="Link target outside of Sample">IV.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat4" title="Link target outside of Sample">Comanche warriors</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat5" title="Link target outside of Sample">V.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat5" title="Link target outside of Sample">A Quahadi Comanche camp</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat6" title="Link target outside of Sample">VI.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat6" title="Link target outside of Sample">A Comanche woman; Tabatoso, a Comanche</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat7" title="Link target outside of Sample">VII.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat7" title="Link target outside of Sample">A Kiowa and his daughters</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat8" title="Link target outside of Sample">VIII.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat8" title="Link target outside of Sample">Kiowas: wife of Big Tree; daughter of Kicking Bird; Kiowa scout</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat9" title="Link target outside of Sample">IX.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat9" title="Link target outside of Sample">Wichita girl, late nineteenth century</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat10" title="Link target outside of Sample">X.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat10" title="Link target outside of Sample">Tawakoni Jim, principal chief of the confederated Wichita, Waco, and Tawakoni tribes; two Wichita women and a baby</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat11" title="Link target outside of Sample">XI.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat11" title="Link target outside of Sample">Sam Houston, a Caddo</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat12" title="Link target outside of Sample">XII.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat12" title="Link target outside of Sample">Caddoes: Nah-ah-sa-nah (known also as Warloupe); Minnie Parton and Charlie Parton</span></p></td>
</tr>
<tr>
<td valign="top"><p class="numberlistn"><span class="nounder" href="#/xhtml/ch13_ps#plat12" title="Link target outside of Sample">XIII.</span></p></td>
<td valign="top"><p class="indentm1"><span class="nounder" href="#/xhtml/ch13_ps#plat12" title="Link target outside of Sample">Sole Comanche survivor of a twelve-man war party raid against the Texas frontier; a Comanche captive</span><a id="page_xviii"></a></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm09_plates.vue?b85d1698